module.exports = __webpack_public_path__ + "static/media/t1.ab41e979.jpg";